import { Link } from "react-router-dom";

export default function CTASection() {
    return (
        <section className="py-20">
            <div className="max-w-7xl mx-auto px-6">

                <div className="relative overflow-hidden rounded-[32px] bg-slate-900 px-8 py-14 md:px-16 md:py-20">

                    {/* Accent */}
                    <div className="absolute top-0 left-0 w-full h-1 bg-[#0F172A]"></div>

                    {/* Decorative */}
                    <div className="absolute -top-24 -right-24 w-72 h-72 bg-[#0F172A]/10 rounded-full blur-3xl"></div>
                    <div className="absolute -bottom-24 -left-24 w-72 h-72 bg-white/5 rounded-full blur-3xl"></div>

                    <div className="relative z-10 text-center">

                        <span className="inline-flex px-4 py-2 rounded-full bg-white/10 text-white/80 text-sm mb-6">
                            Dubai Hotel Deals
                        </span>

                        <h2 className="text-3xl md:text-5xl font-bold !text-white max-w-3xl mx-auto leading-tight">
                            Find Your Perfect Stay in Dubai
                        </h2>

                        <p className="mt-5 !text-white/90 text-lg max-w-2xl mx-auto">
                            Compare hotels, discover exclusive offers, and book with confidence.
                        </p>

                        <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">

                            ```jsx
                            <Link
                                to="/hotels"
                                className="px-8 py-4 bg-[#FF6B35] text-white rounded-xl font-semibold hover:bg-orange-600 transition"
                            >
                                Explore Hotels
                            </Link>
                            ```


                            <Link
                                to="/contact-us"
                                className="px-8 py-4 border border-slate-600 text-white rounded-xl font-semibold hover:bg-white hover:text-slate-900 transition"
                            >
                                Contact Us
                            </Link>

                        </div>

                    </div>

                </div>

            </div>
        </section>
    );
}